import { RootState } from '@types';

export const selectPostProductionPricingData = (state: RootState) => {
    return state.postProductionPricing.data;
};

export const selectIsLoadingPostProductionPricing = (state: RootState) => {
    return state.postProductionPricing.isLoading;
};
